module.exports = __webpack_public_path__ + "img/header-img.2f6f619c.png";